<div class="wrapper">
  <app-secondary-logo />

  <div class="reset-pass-congratulations">
    <div class="reset-pass-congratulations__container">
      <div class="reset-pass-congratulations__title">
        {{ 'reset-pass-congratulations.title' | translate }}
      </div>
      <div class="reset-pass-congratulations__subtitle">
        {{ 'reset-pass-congratulations.subtitle' | translate }}
      </div>
      <button [routerLink]="appRoutes.LOGIN" class="reset-pass-congratulations__button btn-primary">
        {{ 'reset-pass-congratulations.button' | translate }}
      </button>
    </div>
  </div>
  <div class="reset-password-banner">
    <div class="reset-password-banner_picture">
      <img src="assets/images/rocket.png" alt="rocket" />
    </div>
  </div>
</div>
